const theme = {
  token: {
    colorPrimary: '#0eb0b0',
    fontWeightBtn: 500,
    fontWeightBadge: 500,
    fontFamily: 'Quicksand, sans-serif'
  }
};
export default theme;